import { render, staticRenderFns } from "./BaseTLModalDialogPopUp.vue?vue&type=template&id=488c6ca7&"
import script from "./BaseTLModalDialogPopUp.vue?vue&type=script&lang=ts&"
export * from "./BaseTLModalDialogPopUp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports